import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminApi } from './client';

export interface AdminUser {
  id: string;
  email: string;
  name: string;
  role: string;
}

export const authQueryKeys = {
  me: ['auth', 'me'] as const,
};

export function useMe() {
  return useQuery({
    queryKey: authQueryKeys.me,
    queryFn: () => adminApi.get<{ user: AdminUser }>('/auth/me').then(r => r.data.user),
    retry: false,
    staleTime: 60_000,
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => adminApi.post('/auth/logout').then(() => undefined),
    onSuccess: () => {
      qc.clear();
    },
  });
}
